














import Vue from 'vue';
export default Vue.extend({
  name: 'HMEmptySmallSizeCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: { type: String, required: true },
    image: {
      type: String,
      default: 'empty group',
    },
  },
  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
});
